import { useQuery } from "@apollo/client";
import React, { useContext } from "react";
import {
    ConfigData,
    GET_COMMON_CONTENT,
    GetCommonContentData,
    GetCommonContentVariables,
} from "../graphql/queries/common";
import { Content } from "./AppRoot";
import Spinner from "./Spinner";
import styled from "styled-components";

interface Props {
    children: React.ReactNode;
}

export const ConfigContext = React.createContext<ConfigData>(undefined!);

const ConfigContextProvider: React.FC<Props> = ({ children }) => {
    const { code } = useContext(Content);
    const { data, loading } = useQuery<
        GetCommonContentData,
        GetCommonContentVariables
    >(GET_COMMON_CONTENT, {
        variables: {
            langCode: code,
        },
    });

    if (loading) {
        return (
            <Container>
                <Spinner />
            </Container>
        );
    }

    if (data && data.app) {
        return (
            <ConfigContext.Provider value={data.app}>
                {children}
            </ConfigContext.Provider>
        );
    }

    return null;
};

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
`;

export default ConfigContextProvider;
